import { render } from "./BsrEvolutionBarWithValue.vue?vue&type=template&id=428d6acc"
import script from "./BsrEvolutionBarWithValue.vue?vue&type=script&lang=js"
export * from "./BsrEvolutionBarWithValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__